<div class="logo-container">
  <img class="logo" src="assets/images/access-denied/mspm_logo.svg" alt="">
</div>
<div class="background">
  <p class="text" id="Accessdenied">You cannot access this page</p>

  <!-- Task 2616 Phase 8: recovery button shown only for recoverable outcomes
       and only on the first attempt in this browser session. -->
  <p class="text" *ngIf="recoveryFailed">Sign-in recovery could not be completed. Please contact support.</p>
  <ng-container *ngIf="showSignInAgain">
    <p class="text recovery-hint">Your session may have expired or was associated with a different account.</p>
    <button
      class="sign-in-again-btn"
      [disabled]="isRecovering"
      (click)="signInAgain()"
    >
      {{ isRecovering ? 'Redirecting…' : 'Sign in again' }}
    </button>
  </ng-container>
</div>
